import {styled} from '@mui/material';

const MainLayoutRoot = styled('div')(
  ({ theme }) => ({
    // backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  })
);

export default MainLayoutRoot;
